
  /**
  * @name APP u-Planning
  * @autor over.martinez@u-planner.com
  * @description
  * Descripcion del controlador
  * @controller 
  * # name: SubjectsListCtrl
  * # alias: subjectsListVm
  */

export default class SubjectsListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, GlobalConfig, $stateParams, Validations,$state, Requests, $rootScope, $sessionStorage) {
    this.luser = JSON.parse($cookies.get('currentUser'))
    this.subjects = []
    this.totalAsignature = []
    this.viewLoaded = false
    this.itemList = []
    this.itemListOtherAct = []
    this.itemListOtherActAM = []
    this.active = GlobalConfig.generals.active
    this.notActive = GlobalConfig.generals.notActive
    this.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
    this.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    this.planningFinish = true
    this.inReview = 0
    this.feedback = 0
    this.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    this.$sessionStorage = $sessionStorage
    this.Requests = Requests
    this.GlobalConfig = GlobalConfig
    this.WorkPlanSrv = WorkPlanSrv
    this.$rootScope = $rootScope
    this.$timeout = $timeout
    this.$scope = $scope
    this.$mdDialog = $mdDialog

    this.$scope.breakpoints = [
      {
        breakpoint: 3500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },{
        breakpoint: 1850,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },{
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ];

    this.activate()  

  }


  activate () {      
    let post = {
      teacherId: this.luser.teacherId,
      workplanId: this.luser.workplanId
    }

    if(this.workPlanGeneralList != undefined){
      this.status = this.workPlanGeneralList.wokplanTeacherStatus[0]
      this.stages = this.workPlanGeneralList.stages
      this.inReview = this.status.reviewed
      this.feedback = this.status.feedbackReviewed
      this.isPlanning(this.status, this.stages)

      this.Requests.getItemsRequiredList(this.WorkPlanSrv, post).then((data) => {
        this.itemList = data.itemList
        this.itemListOtherAct = data.itemListOtherAct
        this.itemListOtherActAM = data.itemListOtherActAM
        this.workplanTeacherId = this.status.workplanTeacherId
        if(this.feedback && !this.planningFinish){
          this.getAsignaturesAssignedReviewedReject(post)
        }else
          this.getAsignaturesAssigned(post)
      })

    }else{
      this.getGeneralsWorkplan(post).then((promise) => {
        this.Requests.getItemsRequiredList(this.WorkPlanSrv, post).then((data) => {
          this.itemList = data.itemList
          this.itemListOtherAct = data.itemListOtherAct
          this.itemListOtherActAM = data.itemListOtherActAM
          this.workplanTeacherId = this.status.workplanTeacherId
          if(this.feedback && !this.planningFinish){
            this.getAsignaturesAssignedReviewedReject(post)
          }else
            this.getAsignaturesAssigned(post)
        })
      })
    }
  }


  updateView () {
    this.viewLoaded = false
    this.$timeout(() => {
      this.viewLoaded = true
    }, 1000)
  }

  getAsignaturesAssigned (header) {
    return this.WorkPlanSrv.getAsignaturesAssigned.getList(header).$promise.then((dataReturn) => {
      if (dataReturn.status) {
        this.loadData(dataReturn.data)
      } else {
        console.log('Comunications problem with the server')
      }
    },(data) => {
      console.log(data)
    })
  }

  getAsignaturesAssignedReviewedReject (header) {
    return this.WorkPlanSrv.getAsignaturesAssignedReviewedReject.getList(header).$promise.then((dataReturn) => {
      if (dataReturn.status) {
        //console.log("dataReturn--->", dataReturn)
        this.loadData(dataReturn.data)
      } else {
        console.log('Comunications problem with the server')
      }
    },(data) => {
      console.log(data)
    })
  }

  getGeneralsWorkplan(post){
    return this.WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then((dataReturn) => {
      if(dataReturn.status){
        //console.log(dataReturn.data)
        this.$sessionStorage.workPlanGeneralList = dataReturn.data
        this.status = dataReturn.data.wokplanTeacherStatus[0]
        this.stages = dataReturn.data.stages
        this.inReview = this.status.reviewed
        this.feedback = this.status.feedbackReviewed
        this.isPlanning(this.status, this.stages)
      }else{
        console.log("Comunications problem with the server")
      }
    },(data) => {
         console.log(data);
    })
  }

  isPlanning (status, stages) {
    this.currentDate = moment(new Date()).format("DD/MM/YYYY")
    for (var i = stages.length - 1; i >= 0; i--) {
      if(stages[i].stageId == this.GlobalConfig.workplanIdStages.review){
        this.startDateStage = stages[i].startDate
      }
    }

    if (status.planningFinish == this.active){
      this.planningFinish = true
      if (this.startDateReview < this.currentDate || status.reviewedFinish == this.active){
        this.planningFinish = true
      }else if (status.reviewedReject == this.active){
        this.planningFinish = false
      }
    }
     else {
      this.planningFinish = false
    }
  }

  loadData (data) {
    this.subjectsData = data
    this.subjects = this.subjectsData.map(subject => {
      if (subject.periodicityName) {
        subject.periodicityNameArray = subject.periodicityName.split(',')
      }
      if(subject.hoursPlanned > 0){
        subject.asignatureHours = subject.hoursPlanned
      }
      else{
        subject.asignatureHours = 0
      }
      subject.checkPlanningProcess = false 
      return subject
    })
    this.getTotalAssignatures()
    this.updateView()
  }

  backgroundGrad (index) {
    let result = 'grad-oblique-'

    switch (index % 4) {
      case 0:
        return result + 'negro-dark'
      case 1:
        return result + 'azul'
      case 2:
        return result + 'teal'
      case 3:
        return result + 'deep-orange'
      default:
        return result + 'negro-dark'
    }
  }

  updateView () {
    this.viewLoaded = false
    this.$timeout(() => {
      this.viewLoaded = true
    }, 1)
  }

  getItemListByAssignature (subject) {
    var color = ''

    if(subject.isForPlanning === 0)
      color = 'gris-darker'

    if(subject.asignatureHours > 0 && subject.totalHoursPlanned == 0)
      color = 'gris-darker'

    if(subject.totalHoursPlanned > 0 && subject.isForPlanning === 1)
      color = 'verde'

    if(subject.totalHoursPlanned === 0 && subject.isForPlanning === 1)
      color = 'amarillo'

    if(subject.isForPlanning === 1){
      console.log()
      for (var i in this.itemList){
          console.log()
          if(this.itemList[i].assignatureId === subject.asignatureId){
            console.log()
            if(this.itemList[i].itemList.length > 0){
              color = 'amarillo'
              break
            }
          }
      }
    }
    return color
  }

  getTotalAssignatures () {
        this.totalAsignature = this.subjects.filter(subjets=>{
        return subjets.isForPlanning === 1
      })

        this.$rootScope.totalAsignatures = this.totalAsignature.length
  }

  updateIsPlanning (assignature) {
    assignature.checkPlanningProcess = true
    let params={
      teacherId: this.luser.teacherId,
      assignatureId: assignature.asignatureId,
      isPlanning: assignature.isForPlanning
    }     
    this.WorkPlanSrv.updateAssignatureWorkPlan.post(params).$promise.then(()=>{
      this.getTotalAssignatures()
      assignature.checkPlanningProcess = false
      return;
    })
    return;
  }

  bitacora (ev) {
    let entries = {}

    entries.params = {
      activityTypeId: this.GlobalConfig.activityTypeId.subject,
      workplanTeacherId: this.workplanTeacherId
    }
    entries.title = 'Asignaturas'
    // Entries(this.entries);
    entries.data = undefined
    this.$mdDialog.show({
      controller: 'bitacoraModalCtrl',
      controllerAs: 'bit',
      template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
      parent: angular.element(document.body),
      targetEvent: ev,
      locals: {data: entries},
      clickOutsideToClose: true,
      fullscreen: true
    })
  }
}

SubjectsListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', 'GlobalConfig', '$stateParams', 'Validations','$state', 'Requests', '$rootScope', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/subjects/list/subjectsListCtrl.js